import template from './adpVerticalNavigation.html';
import controller from './adpVerticalNavigation.controller';
import './adpVerticalNavigation.less';

let adpVerticalNavigationComponent = {
  restrict: 'E',
  bindings: {
  	items: '<',
  },
  template,
  controller
};

export default adpVerticalNavigationComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpVerticalNavigation/adpVerticalNavigation.component.js